import request from "@/utils/request";

export const url = {
  userList: "/api/Customer/GetPageList", //获取所有客户分页
  userDetail: "/api/Customer/Get", //通过Id查询一个客户
  add: "/api/Customer/Add", //新增客户
  edit: "/api/Customer/Edit", //修改客户
  editgroup: "/api/Customer/EditGroupCustomer", //修改集团客户
  delete: "/api/Customer/Delete", //删除客户
};

export function getUserList(data) {
  return request({
    url: url.userList,
    method: "post",
    data: data,
  });
}
export function getOneUserDetail(data) {
  return request({
    url: url.userDetail,
    method: "post",
    data: data,
  });
}
export function Add(data) {
  return request({
    url: url.add,
    method: "post",
    data: data,
  });
}
export function Edit(data) {
  return request({
    url: url.edit,
    method: "post",
    data: data,
  });
}
export function EditGroup(data) {
  return request({
    url: url.editgroup,
    method: "post",
    data: data,
  });
}
export function Delete(data) {
  return request({
    url: url.delete,
    method: "post",
    data: data,
  });
}
